import { useParams } from 'next/navigation'

export default function useGetSlug() {
  const params = useParams<{ projectId: string }>()
  if (!params?.projectId) return { projectId: '' }
  return params
}
